
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { AnimatePresence, motion } from 'framer-motion';
import * as XLSX from 'xlsx';
import {
  Check,
  Eye,
  AlertCircle,
  Phone,
  Hash,
  User,
  FileText,
  Clock,
  RefreshCw,
  ChevronRight,
  Globe,
  TrendingUp,
  CheckCircle,
  Calendar,
  Search,
  Filter,
  ChevronDown,
  MoreHorizontal,
  Share2,
  TrendingDown,
  X
} from 'lucide-react';

import {
  FiAlertTriangle,
  FiGlobe,
  FiRefreshCw,
  FiDownload,
  FiClock,
  FiCheckCircle,
  FiCalendar,
  FiSearch,
  FiFilter,
  FiAlertCircle,
  FiHash,
  FiChevronDown,
  FiUser,
  FiFileText,
  FiMoreHorizontal,
  FiChevronRight,
  FiCheck,
  FiX,
  FiEye,
  FiShare2
} from 'react-icons/fi';


import DemandeDetail from './DemandeDetail';
import api from '../../api';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const API_BASE = '/demandes';

const DemandeList = ({ isNavbarOpen }) => {
  const [demandes, setDemandes] = useState([]);
  const [filteredDemandes, setFilteredDemandes] = useState([]);
  const [joursMap, setJoursMap] = useState({});
  const [selectionnee, setSelectionnee] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('id');
  const [sortOrder, setSortOrder] = useState('desc');
  const [exporting, setExporting] = useState(false);

  const [stats, setStats] = useState({
    total: 0,
    pending: 0,
    validated: 0,
    avgDays: 0,
    totalGrowth: 0,
    pendingGrowth: 0,
    validatedGrowth: 0,
    avgDaysGrowth: 0
  });
  const [showReturnModal, setShowReturnModal] = useState(false);
  const [causeText, setCauseText] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const [selectedDemande, setSelectedDemande] = useState(null);
  const [chefIdRaw, setChefIdRaw] = useState(null);
  const handleExportExcel = async () => {
    setExporting(true);
    try {
      const exportData = filteredDemandes.map((demande, index) => ({
        'N°': index + 1,
        'ID Demande': demande.id,
        'Organisation Cliente': demande.ticket.organisation.nomOrganisation,
        'Description de la Demande': demande.ticket.nom,
        'Jours Demandés': demande.nbr_jrs || 0,
        'Jours Validés': joursMap[demande.id] || demande.nbr_jrs || 0,
        'Statut': demande.accepter === '3' ? 'En attente' : demande.accepter === '1' ? 'Validé' : 'Refusé',
        'Confirmation Admin': demande.confirmation_admin === '0' ? 'Non' : 'Oui',
        'Date de Création': demande.created_at ? new Date(demande.created_at).toLocaleDateString('fr-FR') : 'N/A',
        'Type de Ticket': demande.ticket.type || 'Standard',
        'Priorité': demande.ticket.priorite || 'Normale'
      }));

      const statsData = [
        { 'Indicateur': 'Total des demandes', 'Valeur': stats.total },
        { 'Indicateur': 'Demandes en attente', 'Valeur': stats.pending },
        { 'Indicateur': 'Demandes validées', 'Valeur': stats.validated },
        { 'Indicateur': 'Moyenne de jours par demande', 'Valeur': stats.avgDays },
        { 'Indicateur': 'Taux de validation', 'Valeur': `${stats.total > 0 ? Math.round((stats.validated / stats.total) * 100) : 0}%` },
        { 'Indicateur': 'Date d\'export', 'Valeur': new Date().toLocaleDateString('fr-FR') },
        { 'Indicateur': 'Heure d\'export', 'Valeur': new Date().toLocaleTimeString('fr-FR') }
      ];

      const workbook = XLSX.utils.book_new();
      const mainWorksheet = XLSX.utils.json_to_sheet(exportData);
      
      const colWidths = [
        { wch: 5 }, { wch: 12 }, { wch: 30 }, { wch: 40 }, { wch: 15 }, 
        { wch: 15 }, { wch: 12 }, { wch: 18 }, { wch: 15 }, { wch: 15 }, { wch: 12 }
      ];
      mainWorksheet['!cols'] = colWidths;

      const statsWorksheet = XLSX.utils.json_to_sheet(statsData);
      statsWorksheet['!cols'] = [{ wch: 25 }, { wch: 20 }];

      XLSX.utils.book_append_sheet(workbook, mainWorksheet, 'Demandes');
      XLSX.utils.book_append_sheet(workbook, statsWorksheet, 'Statistiques');

      const timestamp = new Date().toISOString().slice(0, 19).replace(/[:.]/g, '-');
      const filename = `demandes-validation-${timestamp}.xlsx`;

      XLSX.writeFile(workbook, filename);

      toast.success(`Export Excel réussi ! ${exportData.length} demandes exportées`, {
        position: 'top-right',
        autoClose: 500,
        icon: '📊'
      });

    } catch (error) {
      console.error('Erreur lors de l\'export Excel:', error);
      toast.error('Erreur lors de l\'export Excel');
    } finally {
      setExporting(false);
    }
  };
const handleChangeJours = (id, value) => {
  // Ensure value is a valid number or empty string
  const numericValue = value === '' ? '' : Math.max(0, Math.min(365, parseInt(value) || 0));
  setJoursMap(prev => ({ ...prev, [id]: numericValue }));
};
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userResponse = await api.get('/me', { withCredentials: true });
        if (!userResponse.data.success) {
          console.error('Impossible de récupérer les informations utilisateur.');
          return;
        }

        const user = userResponse.data.user;
        setChefIdRaw(parseInt(user.id, 10));
      } catch (error) {
        console.error('Erreur lors de la récupération des informations utilisateur.');
      }
    };

    fetchUser();
  }, []);



  const chefId = chefIdRaw ? parseInt(chefIdRaw, 10) : null;

  // Fonction pour calculer les statistiques dynamiques
  const calculateStats = (allDemandes) => {
    const now = new Date();
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();

    // Mois précédent
    const lastMonth = currentMonth === 0 ? 11 : currentMonth - 1;
    const lastMonthYear = currentMonth === 0 ? currentYear - 1 : currentYear;

    // Filtrer les demandes du mois actuel
    const demandesCeMois = allDemandes.filter(d => {
      const createdAt = new Date(d.created_at);
      return createdAt.getMonth() === currentMonth && createdAt.getFullYear() === currentYear;
    });

    // Filtrer les demandes du mois précédent
    const demandesMoisPrecedent = allDemandes.filter(d => {
      const createdAt = new Date(d.created_at);
      return createdAt.getMonth() === lastMonth && createdAt.getFullYear() === lastMonthYear;
    });

    // Statistiques pour tous les temps
    const statsAllTime = {
      total: allDemandes.length,
      pending: allDemandes.filter(d => d.confirmation_admin === 0 && d.accepter === '1').length,
      validated: allDemandes.filter(d => d.confirmation_admin === 1).length,
      avgDays: 0
    };

    // Calcul des jours moyens pour tous les temps
    const avecJoursAllTime = allDemandes.filter(d => d.nbr_jrs_valider !== null && !isNaN(d.nbr_jrs_valider) && d.nbr_jrs_valider > 0);
    if (avecJoursAllTime.length > 0) {
      statsAllTime.avgDays = Math.round(
        avecJoursAllTime.reduce((acc, d) => acc + Number(d.nbr_jrs_valider), 0) / avecJoursAllTime.length
      );
    }

    // Statistiques mois actuel
    const statsCeMois = {
      total: demandesCeMois.length,
      pending: demandesCeMois.filter(d => d.confirmation_admin === 0 && d.accepter === '1').length,
      validated: demandesCeMois.filter(d => d.confirmation_admin === 1).length,
      avgDays: 0
    };

    const avecJoursCeMois = demandesCeMois.filter(d => d.nbr_jrs_valider !== null && !isNaN(d.nbr_jrs_valider) && d.nbr_jrs_valider > 0);
    if (avecJoursCeMois.length > 0) {
      statsCeMois.avgDays = Math.round(
        avecJoursCeMois.reduce((acc, d) => acc + Number(d.nbr_jrs_valider), 0) / avecJoursCeMois.length
      );
    }

    // Statistiques mois précédent
    const statsMoisPrecedent = {
      total: demandesMoisPrecedent.length,
      pending: demandesMoisPrecedent.filter(d => d.confirmation_admin === 0 && d.accepter === '1').length,
      validated: demandesMoisPrecedent.filter(d => d.confirmation_admin === 1).length,
      avgDays: 0
    };

    const avecJoursMoisPrecedent = demandesMoisPrecedent.filter(d => d.nbr_jrs_valider !== null && !isNaN(d.nbr_jrs_valider) && d.nbr_jrs_valider > 0);
    if (avecJoursMoisPrecedent.length > 0) {
      statsMoisPrecedent.avgDays = Math.round(
        avecJoursMoisPrecedent.reduce((acc, d) => acc + Number(d.nbr_jrs_valider), 0) / avecJoursMoisPrecedent.length
      );
    }

    // Calcul des pourcentages de croissance
    const calculateGrowth = (current, previous) => {
      if (previous === 0) return current > 0 ? 100 : 0;
      return Math.round(((current - previous) / previous) * 100);
    };

    return {
      ...statsAllTime,
      totalGrowth: calculateGrowth(statsCeMois.total, statsMoisPrecedent.total),
      pendingGrowth: calculateGrowth(statsCeMois.pending, statsMoisPrecedent.pending),
      validatedGrowth: calculateGrowth(statsCeMois.validated, statsMoisPrecedent.validated),
      avgDaysGrowth: calculateGrowth(statsCeMois.avgDays, statsMoisPrecedent.avgDays)
    };
  };

  const refreshData = async () => {
    try {
      setLoading(true);
      const data = await fetchDemandes();
      setDemandes(data);
      setFilteredDemandes(data);
    } catch (error) {
      console.error("Erreur lors du rafraîchissement:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchDemandes = async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await api.get(API_BASE);
      const filteredData = data.demandes.filter(d => Number(d.demandes?.confirmation_admin) === Number(0) && (d.demandes?.accepter) === Number(1));
      const allDemandes = data.demandes;

      setDemandes(allDemandes);
      setFilteredDemandes(filteredData);

      // Calculer les statistiques dynamiques
      const calculatedStats = calculateStats(allDemandes);
      setStats(calculatedStats);

    } catch {
      const msg = 'Impossible de charger les demandes';
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDemandes();
  }, []);

  // Filtrage et recherche
  useEffect(() => {
    // Étape 1 : base à afficher = demandes en attente (confirmation_admin === 0 et accepter === '1')
    let baseFiltered = demandes.filter(d => d.confirmation_admin === 0 && d.accepter === '1');

    // Étape 2 : recherche
    if (searchTerm) {
      baseFiltered = baseFiltered.filter(d =>
        d.ticket.nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
        d.ticket.organisation.nomOrganisation.toLowerCase().includes(searchTerm.toLowerCase()) ||
        d.id.toString().includes(searchTerm)
      );
    }

    // Étape 3 : tri
    baseFiltered.sort((a, b) => {
      let aValue, bValue;
      switch (sortBy) {
        case 'client':
          aValue = a.ticket.organisation.nomOrganisation;
          bValue = b.ticket.organisation.nomOrganisation;
          break;
        case 'demande':
          aValue = a.ticket.nom;
          bValue = b.ticket.nom;
          break;
        case 'jours':
          aValue = a.nbr_jrs || 0;
          bValue = b.nbr_jrs || 0;
          break;
        default:
          aValue = a.id;
          bValue = b.id;
      }

      if (typeof aValue === 'string') {
        return sortOrder === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
      }
      return sortOrder === 'asc' ? aValue - bValue : bValue - aValue;
    });

    // Étape 4 : appliquer à l'état
    setFilteredDemandes(baseFiltered);
  }, [demandes, searchTerm, sortBy, sortOrder]);

  const handleChangeValider = (id, val) => {
    setJoursMap(prev => ({ ...prev, [id]: val }));
  };

  const updateDemande = async (d, updates) => {
    setError(null);
    if (!chefId) {
      const msg = "Identifiant de projet invalide";
      setError(msg);
      toast.error(msg);
      return;
    }

    const payload = { ...updates, chef_de_projet_id: chefId };

    try {
      const { data } = await api.post(`${API_BASE}/${d.id}`, payload);
      setJoursMap(prev => {
        const next = { ...prev };
        delete next[data.id];
        return next;
      });
      toast.success('Validation enregistrée avec succès');
      fetchDemandes();
    } catch (err) {
      const msg = err.response?.data?.message || 'Erreur serveur';
      console.error('Erreur mise à jour:', err.response?.data);
      setError(msg);
      toast.error(msg);
    }
  };

  const handleValider = d => {
    const valider = Number(joursMap[d.id] || 0);
    updateDemande(d, { nbr_jrs_valider: valider, confirmation_admin: '1', accepter: '1' });
  };
  const handleRefuser = (d) => {
    setSelectedDemande(d);
    setShowReturnModal(true);
  };

  const handleConfirmReject = async () => {
    if (!causeText.trim() || !selectedDemande) return;

    setIsProcessing(true);
    try {
      await updateDemande(selectedDemande, {
        accepter: '2',
        confirmation_admin: '2',
        cause_reject: causeText
      });

      toast.success('Demande refusée avec succès');
      setShowReturnModal(false);
      setCauseText('');
    } catch (error) {
      toast.error('Erreur lors du refus de la demande');
      console.error('Erreur:', error);
    } finally {
      setIsProcessing(false);
    }
  };

  // const handleRefuser = async (d) => {  // Add parameter to receive the demande object
  //   try {
  //     await updateDemande(d, {  // Pass the demande object and updates
  //       accepter: '2', 
  //       confirmation_admin: '2'
  //     });

  //     toast.success('Demande refusée avec succès');
  //   } catch (error) {
  //     toast.error('Erreur lors du refus de la demande');
  //     console.error('Erreur:', error);
  //   }
  // };
  const handleSort = (field) => {
    if (sortBy === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(field);
      setSortOrder('asc');
    }
  };

  // Fonction pour formater les pourcentages avec icônes
  const formatGrowth = (growth) => {
    if (growth > 0) {
      return (
        <div className="flex items-center text-sm">
          <TrendingUp className="text-green-500 mr-1" />
          <span className="text-green-500">+{growth}%</span>
          <span className="text-gray-500 ml-1">vs mois dernier</span>
        </div>
      );
    } else if (growth < 0) {
      return (
        <div className="flex items-center text-sm">
          <TrendingDown className="text-red-500 mr-1" />
          <span className="text-red-500">{growth}%</span>
          <span className="text-gray-500 ml-1">vs mois dernier</span>
        </div>
      );
    } else {
      return (
        <div className="flex items-center text-sm">
          <span className="text-gray-500">Aucun changement</span>
        </div>
      );
    }
  };
  return (
    <div className={`bg-gradient-to-br from-slate-50 to-blue-50 min-h-screen ${isNavbarOpen ? 'lg:pl-64 pl-0' : 'lg:pl-20 pl-0'} transition-all duration-300`}>
      {/* Modal de retour fonctionnel - inchangé */}
            {showReturnModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            className="bg-white rounded-xl p-6 max-w-md w-full mx-4 shadow-lg"
          >
            <div className="flex items-center mb-4">
              <div className="bg-red-100 p-2 rounded-full mr-3">
                <FiAlertTriangle className="text-red-600" size={20} />
              </div>
              <h3 className="text-lg font-semibold text-gray-800">Raison du refus</h3>
            </div>
            <p className="text-gray-600 mb-4 text-sm">
              Veuillez saisir une raison pour refuser la demande <strong className="text-gray-800">"{selectedDemande?.ticket?.nom}"</strong>.
            </p>

            <textarea
              className="w-full border border-gray-300 rounded-lg px-4 py-3 mb-4 text-sm focus:outline-none focus:ring-2 focus:ring-red-300 focus:border-transparent resize-none"
              rows={4}
              placeholder="Saisissez la raison du refus..."
              value={causeText}
              onChange={(e) => setCauseText(e.target.value)}
              disabled={isProcessing}
            />

            <div className="flex justify-end space-x-3">
              <button
                onClick={() => {
                  setShowReturnModal(false);
                  setCauseText('');
                }}
                disabled={isProcessing}
                className="px-4 py-2 text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors duration-200"
              >
                Annuler
              </button>
              <button
                disabled={!causeText.trim() || isProcessing}
                onClick={handleConfirmReject}
                className={`px-4 py-2 text-white rounded-lg transition-colors duration-200 flex items-center gap-2 ${causeText.trim() && !isProcessing
                    ? "bg-red-600 hover:bg-red-700"
                    : "bg-red-300 cursor-not-allowed"
                  }`}
              >
                {isProcessing ? (
                  <>
                    <motion.div
                      className="w-4 h-4 border-2 border-white border-t-transparent rounded-full"
                      animate={{ rotate: 360 }}
                      transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
                    />
                    Traitement...
                  </>
                ) : (
                  "Confirmer le refus"
                )}
              </button>
            </div>
          </motion.div>
        </div>
      )}


      <div className="p-4 md:p-6 lg:p-8 h-full flex flex-col max-w-[1400px] mx-auto">
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />

        {/* Header avec breadcrumb - optimisé mobile */}
        <div className="mb-6 md:mb-8">
          <div className="flex items-center text-xs md:text-sm text-slate-600 mb-2 flex-wrap">
            <FiGlobe className="mr-2 text-terrecuite-600" />
            <span>Gestion Globale</span>
            <span className="mx-2">/</span>
            <span className="font-medium text-terrecuite-700">Validation des Demandes</span>
          </div>
          <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-3 md:gap-4">
            <div className="mb-3 md:mb-0">
              <h1 className="text-2xl md:text-3xl font-bold text-slate-800 mb-2">
                Centre de Validation
              </h1>
              <p className="text-sm md:text-base text-slate-600">
                Validez les demandes clients et gérez les jours de travail alloués
              </p>
            </div>
            <div className="flex items-center gap-2 md:gap-3 flex-wrap">
              <button
                onClick={fetchDemandes}
                disabled={loading}
                className="flex items-center px-3 py-1.5 md:px-4 md:py-2 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50 shadow-sm text-sm md:text-base"
              >
                <FiRefreshCw className={`mr-1 md:mr-2 text-terrecuite-600 ${loading ? 'animate-spin' : ''}`} />
                Actualiser
              </button>
              <button
                onClick={handleExportExcel}
                disabled={exporting}
                className="flex items-center px-3 py-1.5 md:px-4 md:py-2 bg-terrecuite-600 text-white rounded-lg hover:bg-terrecuite-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed shadow-sm text-sm md:text-base"
              >
                {exporting ? (
                  <>
                    <div className="animate-spin rounded-full h-3 w-3 md:h-4 md:w-4 border-b-2 border-white mr-1 md:mr-2"></div>
                    Export...
                  </>
                ) : (
                  <>
                    <FiDownload className="mr-1 md:mr-2" />
                    Exporter
                  </>
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Statistiques dynamiques - responsive grid */}
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 lg:gap-6 mb-6 md:mb-8">
          {[
            {
              label: "Total",
              value: stats.total,
              icon: FiFileText,
              color: "text-blue-600",
              bgColor: "bg-blue-100"
            },
            {
              label: "En attente",
              value: stats.pending,
              icon: FiClock,
              color: "text-orange-600",
              bgColor: "bg-orange-100"
            },
            {
              label: "Validées",
              value: stats.validated,
              icon: FiCheckCircle,
              color: "text-green-600",
              bgColor: "bg-green-100"
            },
            {
              label: "Jours moyens",
              value: stats.avgDays,
              icon: FiCalendar,
              color: "text-terrecuite-600",
              bgColor: "bg-terrecuite-100"
            }
          ].map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="bg-white rounded-xl p-4 md:p-6 shadow-sm border border-gray-100"
            >
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs md:text-sm font-medium text-gray-600">{stat.label}</p>
                  <p className={`text-xl md:text-2xl lg:text-3xl font-bold ${stat.color}`}>{stat.value}</p>
                </div>
                <div className={`p-2 md:p-3 ${stat.bgColor} rounded-full`}>
                  <stat.icon className={stat.color} size={18} />
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Filtres et recherche - optimisé mobile */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="bg-white rounded-xl p-4 md:p-6 shadow-sm border border-gray-100 mb-4 md:mb-6"
        >
          <div className="flex flex-col md:flex-row md:items-center gap-3 md:gap-4">
            <div className="flex-1 relative">
              <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                placeholder="Rechercher par client, demande ou ID..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-2 md:py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-terrecuite-300 focus:border-transparent transition-all text-sm md:text-base"
              />
            </div>
            <div className="flex items-center gap-2 md:gap-3">
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="px-3 py-2 md:px-4 md:py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-terrecuite-300 focus:border-transparent text-sm md:text-base"
              >
                <option value="id">ID</option>
                <option value="client">Client</option>
                <option value="demande">Demande</option>
                <option value="jours">Jours</option>
              </select>
              <button
                onClick={() => setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')}
                className="px-3 py-2 md:px-4 md:py-3 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
                title={`Tri ${sortOrder === 'asc' ? 'croissant' : 'décroissant'}`}
              >
                <FiFilter className={`transform ${sortOrder === 'desc' ? 'rotate-180' : ''} transition-transform text-gray-600`} />
              </button>
            </div>
          </div>
        </motion.div>

        {/* Message d'erreur */}
        {error && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-4 md:mb-6 p-3 md:p-4 bg-red-50 border-l-4 border-red-500 rounded-r shadow-sm"
          >
            <div className="flex items-center">
              <FiAlertCircle className="text-red-500 mr-2 md:mr-3 h-4 w-4 md:h-5 md:w-5 flex-shrink-0" />
              <span className="text-red-700 font-medium text-sm md:text-base">{error}</span>
            </div>
          </motion.div>
        )}

        {/* Tableau principal - version mobile et desktop */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
          className="bg-white rounded-xl shadow-sm overflow-hidden flex-grow flex flex-col border border-gray-200"
        >
          {loading ? (
            <div className="flex-grow flex items-center justify-center p-8 md:p-12">
              <div className="text-center space-y-4">
                <div className="animate-spin rounded-full h-10 w-10 md:h-12 md:w-12 border-t-2 border-b-2 border-terrecuite-600 mx-auto"></div>
                <p className="text-gray-600 font-medium text-sm md:text-base">Chargement des demandes...</p>
              </div>
            </div>
          ) : filteredDemandes.length === 0 ? (
            <div className="flex-grow flex flex-col items-center justify-center p-8 md:p-12 text-center space-y-3 md:space-y-4">
              <div className="p-3 md:p-4 bg-gray-100 rounded-full mb-1 md:mb-2">
                <FiFileText size={36} className="text-gray-400 md:size-12" />
              </div>
              <h3 className="text-lg md:text-xl font-semibold text-gray-800">
                {searchTerm ? 'Aucun résultat trouvé' : 'Aucune validation en attente'}
              </h3>
              <p className="text-gray-500 max-w-md mx-auto text-sm md:text-base">
                {searchTerm
                  ? 'Essayez de modifier vos critères de recherche'
                  : 'Toutes les demandes ont été validées ou aucune demande n\'est en attente de validation'
                }
              </p>
              {searchTerm && (
                <button
                  onClick={() => setSearchTerm('')}
                  className="mt-3 md:mt-4 px-3 py-1.5 md:px-4 md:py-2 bg-terrecuite-600 text-white rounded-lg hover:bg-terrecuite-700 transition-colors shadow-sm hover:shadow-md text-sm md:text-base"
                >
                  Effacer la recherche
                </button>
              )}
            </div>
          ) : (
            <>
              {/* Version desktop du tableau */}
              <div className="hidden md:block">
                {/* En-tête du tableau amélioré */}
                <div className="bg-gradient-to-r from-terrecuite-600 to-terrecuite-700 text-white sticky top-0 z-10 shadow-sm">
                  <div className="grid grid-cols-12 px-4 md:px-6 py-3 font-medium text-xs md:text-sm">
                    <div
                      className="col-span-2 flex items-center cursor-pointer hover:text-terrecuite-200 transition-colors group"
                      onClick={() => handleSort('id')}
                    >
                      <FiHash className="mr-1 md:mr-2 group-hover:scale-110 transition-transform" />
                      <span>ID</span>
                      {sortBy === 'id' && (
                        <FiChevronDown className={`ml-1 transition-transform ${sortOrder === 'asc' ? 'rotate-180' : ''}`} size={12} />
                      )}
                    </div>
                    <div
                      className="col-span-3 flex items-center cursor-pointer hover:text-terrecuite-200 transition-colors group"
                      onClick={() => handleSort('client')}
                    >
                      <FiUser className="mr-1 md:mr-2 group-hover:scale-110 transition-transform" />
                      <span>Organisation</span>
                      {sortBy === 'client' && (
                        <FiChevronDown className={`ml-1 transition-transform ${sortOrder === 'asc' ? 'rotate-180' : ''}`} size={12} />
                      )}
                    </div>
                    <div
                      className="col-span-3 flex items-center cursor-pointer hover:text-terrecuite-200 transition-colors group"
                      onClick={() => handleSort('demande')}
                    >
                      <FiFileText className="mr-1 md:mr-2 group-hover:scale-110 transition-transform" />
                      <span>Description</span>
                      {sortBy === 'demande' && (
                        <FiChevronDown className={`ml-1 transition-transform ${sortOrder === 'asc' ? 'rotate-180' : ''}`} size={12} />
                      )}
                    </div>
                    <div className="col-span-2 flex items-center justify-center cursor-default group">
                      <FiClock className="mr-1 md:mr-2 group-hover:text-terrecuite-200 transition-colors" />
                      <span>Jours</span>
                    </div>
                    <div className="col-span-2 flex justify-center cursor-default">
                      <span className="flex items-center">
                        <FiCheckCircle className="mr-1 md:mr-2" />
                        Actions
                      </span>
                    </div>
                  </div>
                </div>

                {/* Corps du tableau amélioré */}
                <div className="divide-y divide-gray-100 overflow-y-auto flex-grow">
                  {filteredDemandes.map((d, index) => (
                    <motion.div
                      key={d.id}
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: index * 0.05 }}
                      className={`grid grid-cols-12 px-4 md:px-6 py-3 md:py-4 items-center text-xs md:text-sm hover:bg-terrecuite-50/30 transition-colors ${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'
                        }`}
                    >
                      {/* Colonne ID */}
                      <div className="col-span-2">
                        <span className="inline-flex items-center px-2 py-0.5 md:px-2.5 md:py-1 rounded-full text-xs font-medium bg-white text-terrecuite-700 border border-terrecuite-300 shadow-sm">
                          #{d.id}
                        </span>
                      </div>

                      {/* Colonne Organisation */}
                      <div className="col-span-3">
                        <div className="flex items-center min-w-0">
                          <div className="flex-shrink-0 w-6 h-6 md:w-8 md:h-8 bg-terrecuite-100 rounded-full flex items-center justify-center mr-2 md:mr-3">
                            <FiUser className="text-terrecuite-600 text-xs" />
                          </div>
                          <div className="min-w-0">
                            <p className="text-xs md:text-sm font-medium text-gray-900 truncate">
                              {d.ticket.organisation.nomOrganisation}
                            </p>
                            <p className="text-xs text-gray-500 truncate">
                              {d.ticket.organisation.contactEmail || 'Email non renseigné'}
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Colonne Description */}
                      <div className="col-span-3">
                        <div className="flex items-center group">
                          <div className="min-w-0">
                            <p className="text-xs md:text-sm font-medium text-gray-900 truncate" title={d.ticket.nom}>
                              {d.ticket.nom}
                            </p>
                            {d.ticket.description && (
                              <p className="text-xs text-gray-500 truncate mt-0.5">
                                {d.ticket.description.substring(0, 35)}...
                              </p>
                            )}
                          </div>
                          <button
                            onClick={() => setSelectionnee(d)}
                            className="ml-1 md:ml-2 opacity-0 group-hover:opacity-100 text-gray-400 hover:text-terrecuite-600 transition-all transform hover:scale-110"
                            title="Voir détails"
                          >
                            <FiChevronRight size={14} />
                          </button>
                        </div>
                      </div>

                      {/* Colonne Jours */}
                      <div className="col-span-2">
                        <div className="flex items-center justify-center space-x-1">
                          <input
                            type="number"
                            min="0"
                            max="365"
                            placeholder={d.nbr_jrs?.toString() || '0'}
                            value={joursMap[d.id] || ''}
                            onChange={e => handleChangeJours(d.id, e.target.value)}
                            className="w-14 md:w-16 px-1 md:px-2 py-0.5 md:py-1 text-center border border-gray-200 rounded text-xs md:text-sm focus:outline-none focus:ring-1 focus:ring-terrecuite-300 transition-all"
                          />
                          <span className="text-xs text-gray-500">jours</span>
                        </div>
                      </div>

                      {/* Colonne Actions */}
                      <div className="col-span-2 flex justify-center space-x-1 md:space-x-2">
                        <button
                          onClick={() => setSelectionnee(d)}
                          className="p-1 text-gray-400 hover:text-terrecuite-600 hover:bg-terrecuite-50 rounded transition-colors"
                          title="Voir les détails"
                        >
                          <FiEye size={14} />
                        </button>
                        <button
                          onClick={() => handleValider(d)}
                          disabled={!joursMap[d.id]}
                          className={`px-1.5 py-0.5 md:px-2 md:py-1 text-white rounded text-xs transition-colors flex items-center ${joursMap[d.id]
                              ? 'bg-green-500 hover:bg-green-600 shadow-sm'
                              : 'bg-gray-300 cursor-not-allowed'
                            }`}
                          title="Valider la demande"
                        >
                          <FiCheck size={10} className="mr-0.5 md:mr-1" />
                          Valider
                        </button>
                        <button
                          onClick={() => handleRefuser(d)}
                          className="px-1.5 py-0.5 md:px-2 md:py-1 bg-red-500 text-white rounded text-xs hover:bg-red-600 transition-colors shadow-sm"
                          title="Refuser la demande"
                        >
                          <FiX size={10} className="mr-0.5 md:mr-1" />
                          Refuser
                        </button>
                      </div>
                    </motion.div>
                  ))}
                </div>

                {/* Footer du tableau amélioré */}
                <div className="bg-terrecuite-50 px-4 md:px-6 py-2 md:py-3 border-t border-terrecuite-100 flex items-center justify-between text-xs text-terrecuite-800">
                  <span>
                    Affichage de <span className="font-medium">1-{filteredDemandes.length}</span> sur {demandes.length} demandes
                  </span>
                  {searchTerm && (
                    <span className="bg-terrecuite-100 px-2 py-0.5 rounded-full">
                      Filtre: "{searchTerm}"
                    </span>
                  )}
                </div>
              </div>

              {/* Version mobile du tableau (cartes) */}
              <div className="md:hidden">
                <div className="p-3 bg-gradient-to-r from-terrecuite-600 to-terrecuite-700 text-white text-center font-medium">
                  Demandes en attente ({filteredDemandes.length})
                </div>
                <div className="divide-y divide-gray-200 overflow-y-auto">
                  {filteredDemandes.map((d, index) => (
                    <motion.div
                      key={d.id}
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: index * 0.05 }}
                      className="p-4 hover:bg-terrecuite-50/30 transition-colors"
                    >
                      <div className="flex justify-between items-start mb-3">
                        <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-white text-terrecuite-700 border border-terrecuite-300 shadow-sm">
                          #{d.id}
                        </span>
                        <div className="flex space-x-1">
                          <button
                            onClick={() => setSelectionnee(d)}
                            className="p-1 text-gray-400 hover:text-terrecuite-600 hover:bg-terrecuite-50 rounded transition-colors"
                            title="Voir les détails"
                          >
                            <FiEye size={14} />
                          </button>
                        </div>
                      </div>

                      <div className="mb-3">
                        <div className="flex items-center mb-2">
                          <div className="flex-shrink-0 w-6 h-6 bg-terrecuite-100 rounded-full flex items-center justify-center mr-2">
                            <FiUser className="text-terrecuite-600 text-xs" />
                          </div>
                          <div>
                            <p className="text-sm font-medium text-gray-900">
                              {d.ticket.organisation.nomOrganisation}
                            </p>
                            <p className="text-xs text-gray-500">
                              {d.ticket.organisation.contactEmail || 'Email non renseigné'}
                            </p>
                          </div>
                        </div>

                        <div className="ml-8">
                          <p className="text-sm font-medium text-gray-900" title={d.ticket.nom}>
                            {d.ticket.nom}
                          </p>
                          {d.ticket.description && (
                            <p className="text-xs text-gray-500 mt-0.5">
                              {d.ticket.description.substring(0, 60)}...
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-2">
                          <span className="text-xs text-gray-600">Jours:</span>
                          <input
                            type="number"
                            min="0"
                            max="365"
                            placeholder={d.nbr_jrs?.toString() || '0'}
                            value={joursMap[d.id] || ''}
                            onChange={e => handleChangeJours(d.id, e.target.value)}
                            className="w-14 px-2 py-1 text-center border border-gray-200 rounded text-sm focus:outline-none focus:ring-1 focus:ring-terrecuite-300 transition-all"
                          />
                        </div>
                        <div className="flex space-x-2">
                          <button
                            onClick={() => handleValider(d)}
                            disabled={!joursMap[d.id]}
                            className={`px-2 py-1 text-white rounded text-xs transition-colors flex items-center ${joursMap[d.id]
                                ? 'bg-green-500 hover:bg-green-600 shadow-sm'
                                : 'bg-gray-300 cursor-not-allowed'
                              }`}
                            title="Valider la demande"
                          >
                            <FiCheck size={10} className="mr-1" />
                            Valider
                          </button>
                          <button
                            onClick={() => handleRefuser(d)}
                            className="px-2 py-1 bg-red-500 text-white rounded text-xs hover:bg-red-600 transition-colors shadow-sm"
                            title="Refuser la demande"
                          >
                            <FiX size={10} className="mr-1" />
                            Refuser
                          </button>
                        </div>
                      </div>
                    </motion.div>
                  ))}
                </div>

                {/* Footer mobile */}
                <div className="bg-terrecuite-50 p-3 border-t border-terrecuite-100 text-center text-xs text-terrecuite-800">
                  <span>
                    {filteredDemandes.length} demandes affichées sur {demandes.length}
                  </span>
                  {searchTerm && (
                    <div className="mt-1 bg-terrecuite-100 px-2 py-0.5 rounded-full inline-block">
                      Filtre: "{searchTerm}"
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </motion.div>

        {/* Modal de détail */}
        <AnimatePresence>
          {selectionnee && (
            <DemandeDetail
              demande={selectionnee}
              onClose={() => setSelectionnee(null)}
            />
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default DemandeList;